import {
  AddChargingServiceImageRequest,
  CreateChargingServiceCTARequest,
  CreateChargingServiceRequest,
  GetChargingServiceImageRequest,
  RemoveChargingServiceCTARequest,
  RemoveChargingServiceImageRequest,
  UpdateChargingServiceMetadataRequest,
  UpdateChargingServiceOperationHoursRequest,
  UpdateChargingServicePaymentMethodsRequest,
  UpdateChargingServiceStoreIdsRequest,
  UpdateChargingServiceTagsRequest,
} from './requests/charging-service-request.ts';
import { apiClient } from './client.tsx';
import {
  AddChargingServiceImageResponse,
  CreateChargingServiceCTAResponse,
  CreateChargingServiceResponse,
  DisableChargingServiceResponse,
  EnableChargingServiceResponse,
  GetChargingServiceImageResponse,
  GetChargingServiceResponse,
  GetEVSEsResponse,
  PauseChargingServiceResponse,
  RemoveChargingServiceCTAResponse,
  RemoveChargingServiceImageResponse,
  RemoveChargingServiceOperationHoursResponse,
  UpdateChargingServiceMetadataResponse,
  UpdateChargingServiceOperationHoursResponse,
  UpdateChargingServicePaymentMethodsResponse,
  UpdateChargingServiceStoreIdsResponse,
  UpdateChargingServiceTagsResponse,
} from './responses/charging-service-response.ts';

export const createChargingService = (request: CreateChargingServiceRequest) =>
  apiClient
    .post<CreateChargingServiceResponse>('/v2/charging_services', request)
    .then((res) => res.data.data);

export const updateChargingServiceMetadata = (
  request: UpdateChargingServiceMetadataRequest,
) =>
  apiClient
    .put<UpdateChargingServiceMetadataResponse>(
      `/v2/charging_services/${request.serviceId}`,
      request,
    )
    .then((res) => res.data.data);

export const getChargingService = (serviceId: string) =>
  apiClient
    .get<GetChargingServiceResponse>(`/v2/charging_services/${serviceId}`)
    .then((res) => res.data.data);

export const createChargingServiceCTA = (
  request: CreateChargingServiceCTARequest,
) =>
  apiClient
    .post<CreateChargingServiceCTAResponse>(
      `/v2/charging_services/${request.serviceId}/call_to_actions`,
      request,
    )
    .then((res) => res.data.data);

export const removeChargingServiceCTA = (
  request: RemoveChargingServiceCTARequest,
) =>
  apiClient
    .delete<RemoveChargingServiceCTAResponse>(
      `/v2/charging_services/${request.serviceId}/call_to_actions/${request.callToActionId}`,
    )
    .then((res) => res.data.data);

export const disableChargingService = (serviceId: string) =>
  apiClient
    .post<DisableChargingServiceResponse>(
      `/v2/charging_services/${serviceId}/disable`,
    )
    .then((res) => res.data.data);

export const enableChargingService = (serviceId: string) =>
  apiClient
    .post<EnableChargingServiceResponse>(
      `/v2/charging_services/${serviceId}/enable`,
    )
    .then((res) => res.data.data);

export const getEVSEs = (serviceId: string) =>
  apiClient
    .get<GetEVSEsResponse>(`/v2/charging_services/${serviceId}/evses`)
    .then((res) => res.data.data);

export const addChargingServiceImage = (
  request: AddChargingServiceImageRequest,
) =>
  apiClient
    .post<AddChargingServiceImageResponse>(
      `/v2/charging_services/${request.serviceId}/images`,
      request.file,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data.data);

export const removeChargingServiceImage = (
  request: RemoveChargingServiceImageRequest,
) =>
  apiClient
    .delete<RemoveChargingServiceImageResponse>(
      `/v2/charging_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const getChargingServiceImage = (
  request: GetChargingServiceImageRequest,
) =>
  apiClient
    .get<GetChargingServiceImageResponse>(
      `/v2/charging_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const updateChargingServiceOperationHours = (
  request: UpdateChargingServiceOperationHoursRequest,
) =>
  apiClient
    .put<UpdateChargingServiceOperationHoursResponse>(
      `/v2/charging_services/${request.serviceId}/operation_hours`,
      request,
    )
    .then((res) => res.data.data);

export const removeChargingServiceOperationHours = (serviceId: string) =>
  apiClient
    .delete<RemoveChargingServiceOperationHoursResponse>(
      `/v2/charging_services/${serviceId}/operation_hours`,
    )
    .then((res) => res.data.data);

export const pauseChargingService = (serviceId: string) =>
  apiClient
    .post<PauseChargingServiceResponse>(
      `/v2/charging_services/${serviceId}/pause`,
    )
    .then((res) => res.data.data);

export const removeChargingService = (serviceId: string) =>
  apiClient.delete(`/v2/charging_services/${serviceId}`);

export const updateChargingServicePaymentMethods = (
  request: UpdateChargingServicePaymentMethodsRequest,
) =>
  apiClient
    .put<UpdateChargingServicePaymentMethodsResponse>(
      `/v2/charging_services/${request.serviceId}/payment_methods`,
      request,
    )
    .then((res) => res.data.data);

export const updateChargingServiceTags = (
  request: UpdateChargingServiceTagsRequest,
) =>
  apiClient
    .put<UpdateChargingServiceTagsResponse>(
      `/v2/charging_services/${request.serviceId}/tags`,
      request,
    )
    .then((res) => res.data.data);

export const updateChargingServiceStoreIds = (
  request: UpdateChargingServiceStoreIdsRequest,
) =>
  apiClient
    .put<UpdateChargingServiceStoreIdsResponse>(
      `/v2/charging_services/${request.serviceId}/stores`,
      request,
    )
    .then((res) => res.data.data);
